/**
 * Returns the global window, with `T` appended to its type.
 */
export function getWindow<T = {}>() {
    if (typeof window !== 'undefined') {
        return window as unknown as Window & T;
    }
}
